import { ApiError } from '@/shared/errors/api-error';

/**
 * A loja só é "não encontrada" quando a API respondeu 404 nos detalhes ou no
 * cardápio. Erro de servidor (500, 503, rede) é instabilidade e não pode
 * aparecer para o cliente como se a loja não existisse (PRAT-39: com o
 * cardápio em 500, todas as lojas de produção pareciam inativas).
 */
export function isStoreNotFound(...errors: unknown[]): boolean {
  const failures = errors.filter(Boolean);
  if (failures.length === 0) return false;

  return failures.every(error => ApiError.isApiError(error) && error.status === 404);
}
